import { mapState } from '@/store/helpers';

export default {
    // props: {
    //     isCompose: {
    //         type: Object,
    //         default: () => null
    //     }
    // },
    computed: {
        ...mapState({
            "onlyMap": store => store.layout === 'map',
            "composeLayout": store => store.layout === 'mixed'
        }),
        showLayoutToggle({
            isMobile,
            layout,
            isGridOrList,
            searchBarOnly,
            hideSearchBtn,
            locationOnly
        }) {
            return (
                isMobile &&
                layout !== 'map' &&
                !isGridOrList &&
                !searchBarOnly &&
                !hideSearchBtn &&
                !locationOnly
            );
        },
        style({ composeLayout }) {
            return composeLayout 
                ? { width: '700px', paddingTop: '20px' } 
                : { width: '100%', paddingTop: '30px', paddingBottom: '30px' };
        },
        // style({ isCompose }) {
        //     if (!isCompose) return { width: '100%', padding: '30px 50px' };
        //     if (isCompose.compose) {
        //         if (!isCompose.onlyMap) {
        //             return { width: '700px', padding: '20px 50px 0 50px' };
        //         } else {
        //             return { width: '100%', padding: '30px 50px' };
        //         }
        //     } else {
        //         return { width: '100%', padding: '30px 50px' };
        //     }
        // },
        // composeLayout({ isCompose }) {
        //     return isCompose && isCompose.compose && !isCompose.onlyMap;
        // },
        // onlyMap({ isCompose }) {
        //     return isCompose && isCompose.compose && isCompose.onlyMap;
        // },
        isMobileSize() {
            return this.platform.isMobile;
        }
    }
};
